import { crudMutations, crudActions, attachmentActions, shipmentActions } from './modules/action-helpers'

const basePath = 'api/shipment'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath }),
    ...attachmentActions({ basePath: basePath }),
    ...shipmentActions({ basePath: basePath })
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/shipments.js